import { ConnectionPositionPair, Overlay, OverlayContainer } from '@angular/cdk/overlay';
import { inject, Injectable, InjectionToken } from '@angular/core';

import type { FigureContextMenuArgs, FigureContextMenuController } from '@core/prosemirror-legacy';
import { WysiwygComponentPortalService } from '@core/prosemirror-legacy/angular';

import { FigureContextMenuComponent } from './figure-context-menu.component';

export const PM_CONTEXT_MENU_SERVICE_IMAGE = new InjectionToken<FigureContextMenuService>(
  'PmContextMenuServiceImage',
);
export const PM_CONTEXT_MENU_SERVICE_VIDEO = new InjectionToken<FigureContextMenuService>(
  'PmContextMenuServiceVideo',
);

export const figureContextMenuServiceProvider = (
  token: InjectionToken<FigureContextMenuService>,
) => ({
  provide: token,
  useFactory: () => new FigureContextMenuService(inject(OverlayContainer), inject(Overlay)),
});

@Injectable()
export class FigureContextMenuService
  extends WysiwygComponentPortalService<FigureContextMenuComponent>
  implements FigureContextMenuController
{
  protected positions: ConnectionPositionPair[] = [
    { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom' },
  ];

  public open(domEl: DOMRect, args: FigureContextMenuArgs) {
    this.close();
    this.openComponent(FigureContextMenuComponent, domEl, this.positions, {
      skipComponentCD: true,
    });
    const { instance, location } = this.componentRef!;
    instance.getAlign = args.getAlign;
    this.componentRef?.changeDetectorRef.detectChanges();
    return {
      element: <HTMLElement>location.nativeElement,
      action$: instance.action$.asObservable(),
    };
  }

  public close() {
    super.close();
  }

  public updatePosition(domRect: DOMRect) {
    const { width, x, y } = domRect;
    const left = x + width / 2;

    super.updatePosition({ left, top: y });
    this.componentRef?.instance.afterUpdatePosition();
  }
}
